<script>
import { pageTitleMixin } from '@ubic/vue-mixins';
import { permissions } from '@/constants';
import ErrorAccessDenied from '@/components/ErrorAccessDenied';
import FormError from '@/components/FormError';
import ProjectFields from './components/ProjectFields';
import service from './service';

export default {
  pageTitle: 'Новый проект',
  mixins: [pageTitleMixin],
  data () {
    return {
      isSaving: false,
      error: '',
      name: '',
      search: '',
      isArchive: false,
    };
  },
  computed: {
    hasWritePermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.PROJECT_WRITE);
    },
  },
  methods: {
    handleFieldsChange ({ name, search, isArchive }) {
      this.name = name;
      this.search = search;
      this.isArchive = isArchive;
    },
    async handleSubmit (e) {
      e.preventDefault();

      if (this.isSaving) {
        return;
      }

      this.isSaving = true;
      this.error = '';

      try {
        const { name, search, isArchive } = this;
        console.log(this);
        await service.create({ name, search, isArchive });

        this.emitDataUpdate();
        this.handleClose();
      } catch (err) {
        console.log(err);
        this.error = 'Ошибка при создании проекта';
        this.isSaving = false;
      }
    },

    handleClose () {
      this.$emit('close');
      this.$router.replace('/projects');
    },
    emitDataUpdate () {
      this.$emit('dataupdate');
    },
  },
  render () {
    if (!this.hasWritePermission) {
      return (
        <u-modal onClose={this.handleClose}>
          <ErrorAccessDenied />
        </u-modal>
      );
    }

    const { error, isSaving } = this;

    return (
      <u-modal onClose={this.handleClose}>
        <u-title
          slot="header"
          level="2"
        >
          Новый проект
        </u-title>

        <form
          action="#"
          method="post"
          onSubmit={this.handleSubmit}
        >
          <ProjectFields
            disabled={isSaving}
            onChange={this.handleFieldsChange}
          />

          {Boolean(error) && (
            <FormError>
              {error}
            </FormError>
          )}

          <footer class="form-footer">
            <u-btn
              type="submit"
              size="wide"
            >
              {isSaving
                ? <u-spinner inline />
                : 'Создать'}
            </u-btn>
          </footer>
        </form>
      </u-modal>
    );
  },
};
</script>
